import { useApplicationTitle } from '@/features/ui/hooks/use-application-title';

// Purpose: Headless component that applies dynamic document.title on application pages
export function DynamicTitle() {
  useApplicationTitle();
  return null;
}

export default DynamicTitle;


